import { useEffect, useState } from "react";
import DataTable from "../../../component/DataTable";
import { Link } from "react-router-dom";
import ApiRequest from "../../../helper/ApiRequest";
import { ApiEndpoints } from "../../../helper/ApiEndpoints";
import { toast } from "react-toastify";
import AdminHeader from "../../../component/AdminHeader";

const DeleteEndpoint = ApiEndpoints.case.Delete;
const ListEndpoint = ApiEndpoints.case.List;
const EditPath = "edit-case-study";
const tableHeader = ["Date", "Title", "Slug"];
const tbody = ["date", "title", "slug"];

export default function CaseStudy() {

  const [data, setData] = useState([]);

  const dataFetch = async () => {
    try {
      const response = await ApiRequest("GET", ListEndpoint);
      const result = response.casestudys;
      setData(result);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    dataFetch();
  }, []);

  const handleDelete = async (casestudy_id) => {
    const payload = { casestudy_id };
    try {
      const response = await ApiRequest("POST", DeleteEndpoint, payload);
      toast.success(response.message)
      dataFetch();
    } catch (error) {
      console.error(error);
    }
  };

  const pagename = {
    name: 'Case Study Management',
    user: 'Admin',
    innerpage: 'Case Study Management / Case Studies'
  }

  return (
    <>
      <AdminHeader pagename={pagename} />

      <div className="add-btn-section">
        <Link className="admin-add-btn" to="/add-case-study">Add +</Link>
        <DataTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          editPath={EditPath}
          onDelete={handleDelete}
        />
      </div>
    </>
  );
}
